up.compiler(
  '[data-load-job-sidebar-async]',
  async (_element: HTMLElement, { target, url }: { target: string; url: string }) => {
    up.render({ target, url, history: false, navigate: false })
  },
)
